
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const InstitutionInfoFields: React.FC = () => {
  const form = useFormContext();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Institution Information</h3>
      
      {/* Institution Address */}
      <FormField
        control={form.control}
        name="institutionAddress"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Institution Address</FormLabel>
            <FormControl>
              <Input
                placeholder="Enter institution address"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {/* Institution Phone and Email */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="institutionPhone"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Institution Phone</FormLabel>
              <FormControl>
                <Input
                  placeholder="Enter institution phone number"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="institutionEmail"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Institution Email</FormLabel>
              <FormControl>
                <Input
                  type="email"
                  placeholder="Enter institution email address"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      {/* Authorized By */}
      <FormField
        control={form.control}
        name="authorizedBy"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Authorized By</FormLabel>
            <FormControl>
              <Input
                placeholder="Enter authorizing person's name"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {/* Policy Note */}
      <FormField
        control={form.control}
        name="policyNote"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Policy Note</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Enter institution policies (e.g., 'Without stamp the slip is invalid')"
                className="min-h-[100px]"
                defaultValue="Without stamp the slip is invalid."
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default InstitutionInfoFields;
